import * as Preact from "preact"

import Navigation from "@frog/source/engine/navigating/Navigation.js"
import {Modals} from "@frog/source/views/ModalUI.jsx"

const UI_MOCKS = {
    "ChapterStart": function() {
        return (
            <div class="Mockup">
                <div class="ChapterUI">
                    <Modals.ChapterStart stage={{"dialogue": {"data": {"text": [
                        "Chapter 1",
                        "The Beginning",
                        "In Which",
                        "Eleanor sneaks onto a ship",
                        "and Sylvester gets more than he bargained for",
                    ]}}}}/>
                </div>
            </div>
        )
    },
    "PlayerTurnStart": function() {
        return (
            <div class="Mockup">
                <div class="ChapterUI">
                    <div class="PlaceholderStage"/>
                    <Modals.TurnStart stage={{"dialogue": {"data": {"affiliation": "good"}}}}/>
                </div>
            </div>
        )
    },
    "NonPlayerTurnStart": function() {
        return (
            <div class="Mockup">
                <div class="ChapterUI">
                    <div class="PlaceholderStage"/>
                    <Modals.TurnStart stage={{"dialogue": {"data": {"affiliation": "bad"}}}}/>
                </div>
            </div>
        )
    },
    "ChapterFailure": function() {
        return (
            <div class="Mockup">
                <div class="PlaceholderStage"/>
                <div class="ChapterUI">
                    <Modals.ChapterFailure/>
                </div>
            </div>
        )
    },
    "ChapterSuccess": function() {
        return (
            <div class="Mockup">
                <div class="ChapterUI">
                    <div class="PlaceholderStage"/>
                    <Modals.ChapterSuccess stage={{
                        "dialogue": {"data": {"phase": 10}},
                        "player": {
                            "affiliation": "good",
                            "party": {
                                "units": {
                                    "good1": {
                                        "experience": 0,
                                        "maxexperience": 100,
                                    },
                                    "good2": {
                                        "experience": 0,
                                        "maxexperience": 100,
                                    },
                                    "good3": {
                                        "experience": 0,
                                        "maxexperience": 100,
                                    },
                                }
                            }
                        },
                        "units": {
                            "bad1": {
                                "isDead": true,
                                "affiliation": "bad",
                                "spriteSize": "contained",
                                "imageUrl": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/rogue_bad.png"),
                            },
                            "bad2": {
                                "isDead": true,
                                "affiliation": "bad",
                                "spriteSize": "contained",
                                "imageUrl": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/berserker_bad.png"),
                            },
                            "bad3": {
                                "isDead": true,
                                "affiliation": "bad",
                                "spriteSize": "contained",
                                "imageUrl": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/berserker_bad.png"),
                            },
                            "bad4": {
                                "isDead": true,
                                "affiliation": "bad",
                                "spriteSize": "contained",
                                "imageUrl": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/cavalry_bad.png"),
                            },
                            "bad5": {
                                "isDead": true,
                                "affiliation": "bad",
                                "spriteSize": "contained",
                                "imageUrl": require("@frog/source/assets/images/hero-tactics/units/@vmenezio/cleric_bad.png"),
                            },
                            "good1": {
                                "affiliation": "good",
                                "spriteSize": "buffered",
                                "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/ally/lord").default,
                            },
                            "good2": {
                                "isDead": true,
                                "affiliation": "good",
                                "spriteSize": "buffered",
                                "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/ally/archer").default,
                            },
                            "good3": {
                                "affiliation": "good",
                                "spriteSize": "buffered",
                                "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/ally/knight").default,
                            },
                        }
                    }}/>
                </div>
            </div>
        )
    },
    "ChapterSuccessClassic": function() {
        return (
            <div class="Mockup">
                <div class="ChapterUI">
                    <div class="PlaceholderStage"/>
                    <Modals.ChapterSuccessClassic/>
                </div>
            </div>
        )
    },
    "Dialogue": function() {
        return (
            <div class="Mockup">
                <div class="ChapterUI">
                    <div class="PlaceholderStage"/>
                    <Modals.Dialogue stage={{
                        "dialogue": {
                            "text": "Hello World!!",
                            "data": {
                                "speakerKey": "swashbuckler",
                                "scene": {
                                    "units": [
                                        {"key": "swashbuckler", "position": 1, "direction": "right", "expression": "happy"},
                                        {"key": "swindler", "position": 4, "direction": "left", "expression": "nervous"},
                                    ]
                                }
                            }
                        },
                        "units": {
                            "swashbuckler": {
                                "name": "Eleanor",
                                "portraits": {
                                    "neutral": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-neutral.png"),
                                    "happy": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-happy.png"),
                                    "wink": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-wink.png"),
                                    "angry": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-angry.png"),
                                    "challenge": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-challenge.png"),
                                    "attack": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-challenge.png"),
                                    "hurt": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-angry.png"),
                                },
                            },
                            "swindler": {
                                "name": "Sylvester",
                                "portraits": {
                                    "neutral": require("@frog/source/assets/images/pirate-tactics/portraits/sylvester-neutral.png"),
                                    "nervous": require("@frog/source/assets/images/pirate-tactics/portraits/sylvester-nervous.png"),
                                    "smooth": require("@frog/source/assets/images/pirate-tactics/portraits/sylvester-smooth.png"),
                                    "attack": require("@frog/source/assets/images/pirate-tactics/portraits/sylvester-smooth.png"),
                                    "hurt": require("@frog/source/assets/images/pirate-tactics/portraits/sylvester-nervous.png"),
                                },
                            }
                        }
                    }}/>
                </div>
            </div>
        )
    },
    "CharacterSplash": function() {
        return (
            <div class="Mockup">
                <div class="ChapterUI">
                    <div class="PlaceholderStage"/>
                    <Modals.CharacterSplash stage={{
                        "dialogue": {
                            "data": {
                                "unitKey": "swashbuckler",
                            },
                        },
                        "units": {
                            "swashbuckler": {
                                "key": "swashbuckler",
                                "name": "Eleanor",
                                "sprites": {
                                    "static": require("@frog/source/assets/images/frog-tactics/stage/units/eleanora.png"),
                                },
                                "portraits": {
                                    "neutral": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-neutral.png"),
                                    "happy": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-happy.png"),
                                    "wink": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-wink.png"),
                                    "angry": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-angry.png"),
                                    "challenge": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-challenge.png"),
                                    "attack": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-challenge.png"),
                                    "hurt": require("@frog/source/assets/images/pirate-tactics/portraits/eleanora-angry.png"),
                                },
                                "health": 30,
                                "maxhealth": 30,
                                "power": 20,
                                "defense": 5,
                                "resistance": 0,
                                "facts": [
                                    "Has a cool hat",
                                ],
                            }
                        }
                    }}/>
                </div>
            </div>
        )
    },
    "CharacterLevelUp": function() {
        return (
            <div class="Mockup">
                <div class="ChapterUI">
                    <div class="PlaceholderStage"/>
                    <Modals.CharacterLevelUp stage={{
                        "dialogue": {
                            "data": {
                                "unitKey": "lord",
                            },
                        },
                        "player": {
                            "party": {
                                "units": {
                                    "lord": {
                                        "key": "lord",
                                        "name": "Oriana",

                                        "spriteSize": "buffered",
                                        "sprites": require("@frog/source/assets/images/hero-tactics-ii/units/ally/lord").default,
                                        "portraits": {
                                            // "neutral": require("@frog/source/assets/images/chess-tactics/portraits/newer/RP-neutral.png"),
                                            "neutral": require("@frog/source/assets/images/chess-tactics/portraits/newer/RP-neutral2.png"),
                                            "angry": require("@frog/source/assets/images/chess-tactics/portraits/newer/RP-angry.png"),
                                            "happy": require("@frog/source/assets/images/chess-tactics/portraits/newer/RP-happy.png"),
                                        },


                                        "level": 1,
                                        "levelups": {
                                            2: [
                                                {"key": "maxhealth", "value": 10},
                                                {"key": "maxexperience", "value": 50},
                                                // {"key": "skill", "value": "rally"},
                                                {
                                                    "key": "jobKeys",
                                                    "values": [
                                                        "hero/bladesinger",
                                                        "hero/firefist"
                                                    ]
                                                },
                                            ],
                                        },

                                        "maxhealth": 40,
                                    }
                                }
                            }
                        }
                    }}/>
                </div>
            </div>
        )
    },
}

export default function DevUiScreen() {
    if(UI_MOCKS[Navigation.state.uislug] != undefined) {
        const UI = UI_MOCKS[Navigation.state.uislug]
        return (
            <div class="DivUiScreen" key={Navigation.state.startTime}>
                <UI/>
            </div>
        )
    }
}
